// Define environment variables with fallbacks
const SERVER_ROOT = process.env.REACT_APP_SERVER_ROOT;
const FILES_ROOT = process.env.REACT_APP_FILES_ROOT;
 
const GLOBALVAR = {
  SERVER_ROOT: SERVER_ROOT || 'https://api.hayahaycorp.com',
  FILES_ROOT: FILES_ROOT || 'https://files.hayahaycorp.com'
};

export default GLOBALVAR;